import { useState, useRef } from 'react';
import './Contact.css';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8000';

const IconPin = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/><circle cx="12" cy="9" r="2.5"/></svg>
);
const IconMail = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><rect x="2" y="4" width="20" height="16" rx="3"/><path d="M2 7l10 7 10-7"/></svg>
);
const IconPhone = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81a19.79 19.79 0 01-3.07-8.68A2 2 0 012 0h3a2 2 0 012 1.72c.127 1 .36 1.98.7 2.91a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.17-1.17a2 2 0 012.11-.45c.93.34 1.91.573 2.91.7A2 2 0 0122 14.92v2z"/></svg>
);
const IconClock = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>
);

const infoCards = [
  {
    icon: <IconPin />,
    title: 'Visit Us',
    lines: ['D-11, Thilai Nagar, 6th Cross Rd,', 'Trichy – 620018'],
  },
  {
    icon: <IconMail />,
    title: 'Email Us',
    lines: ['aerialrootinfotech@gmail.com'],
  },
  {
    icon: <IconPhone />,
    title: 'Call Us',
    lines: ['+91 90802 67314', '+91 96292 67314'],
  },
  {
    icon: <IconClock />,
    title: 'Working Hours',
    lines: ['Mon – Sat: 9:00 AM – 8:00 PM', 'Sunday: Closed'],
  },
];

export default function Contact() {
  const formRef = useRef();
  const [status, setStatus] = useState('idle');

  async function handleSubmit(e) {
    e.preventDefault();
    setStatus('sending');
    try {
      const fd = new FormData(formRef.current);
      const payload = {
        name:    fd.get('from_name') || '',
        phone:   fd.get('phone') || '',
        email:   fd.get('reply_to') || '',
        service: '',
        message: fd.get('message') || '',
      };
      const r = await fetch(`${API_BASE}/api/contact`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      if (!r.ok) throw new Error('Failed to submit');
      setStatus('success');
      formRef.current.reset();
    } catch (err) {
      console.error(err);
      setStatus('error');
    }
  }

  return (
    <section id="contact" className="ct-section ct-warm">

      {/* ── TOP INFO CARDS ── */}
      <div className="ct-info-row reveal">
        {infoCards.map((c) => (
          <div className="ct-info-card" key={c.title}>
            <span className="ct-info-icon">{c.icon}</span>
            <h4 className="ct-info-title">{c.title}</h4>
            <p className="ct-info-text">
              {c.lines.map((l, i) => <span key={i}>{l}<br /></span>)}
            </p>
          </div>
        ))}
      </div>

      {/* ── FORM BAND ── */}
      <div className="ct-form-band">
        <p className="ct-eyebrow">Send a Message</p>
        <h2 className="ct-heading">We'd love to hear from you</h2>

        <div className="ct-card reveal d2">
          <form ref={formRef} onSubmit={handleSubmit} className="ct-form">

            <div className="ct-row">
              <div className="ct-field">
                <label className="ct-field-label">Your Name</label>
                <input type="text" name="from_name" placeholder="John Doe" required autoComplete="off" />
              </div>
              <div className="ct-field">
                <label className="ct-field-label">Email</label>
                <input type="email" name="reply_to" placeholder="john@example.com" required autoComplete="off" />
              </div>
            </div>

            <div className="ct-field">
              <label className="ct-field-label">Phone Number</label>
              <input type="tel" name="phone" placeholder="+91 98765 43210" autoComplete="off" />
            </div>

            <div className="ct-field">
              <label className="ct-field-label">Message</label>
              <textarea name="message" rows={4} placeholder="Tell us what you're looking for…" required />
            </div>

            <button type="submit" className="ct-submit" disabled={status === 'sending'}>
              {status === 'sending' ? 'Sending…' : 'Send Message'}
            </button>

            {status === 'success' && (
              <div className="ct-status ct-status--ok">✅ Message sent! We'll get back to you within 24 hours.</div>
            )}
            {status === 'error' && (
              <div className="ct-status ct-status--err">❌ Something went wrong. Please try again or WhatsApp us directly.</div>
            )}
          </form>
        </div>
      </div>

      {/* Map strip */}
      <div className="ct-map-strip reveal d3">
        <iframe
          title="AerialRoot location map"
          src="https://maps.google.com/maps?q=Aerialroot%20Academy%20Digital%20Marketing%20%26%20AI%20Training%20Institute%20Trichy&t=&z=15&ie=UTF8&iwloc=&output=embed"
          width="100%"
          height="420"
          style={{ border: 0, display: 'block' }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>

    </section>
  );
}
